// "N waiting to upload · Send now" (row #40, 2026-10-19): one badge for every
// queued item (captures, MSQA forms and photos, AR scan frames), shown in the
// field app and the AR scan view. It follows the queue (onOutboxChange) and
// refreshes every 5 s while it is on the page, so "2 min ago" stays true.

import { h } from "./dom";
import { drain, onOutboxChange, outboxStatus } from "./outbox";
import { badgeText } from "./uploadStatus";

export function uploadBadge(opts: { className?: string; onOpen?: () => void } = {}): HTMLElement {
  const head = h("strong", { class: "fa-upq-head" });
  const detail = h("small", { class: "fa-upq-detail" });
  const send = h("button", { type: "button", class: "fa-btn fa-upq-send", onclick: (e: Event) => {
    e.stopPropagation();
    send.setAttribute("disabled", "");
    void drain({ force: true }).finally(() => send.removeAttribute("disabled"));
  } }, "Send now");
  const el = h("div", { class: `fa-upq ${opts.className ?? ""}`, role: "status", "aria-live": "polite", hidden: true },
    h("span", { class: "fa-upq-main", onclick: () => opts.onOpen?.() }, head, detail), send);
  let pending = false;
  const refresh = () => {
    if (pending) return;
    pending = true;
    void outboxStatus().then((st) => {
      const t = badgeText(st, Date.now());
      el.hidden = !t.show;
      el.dataset.tone = t.tone;
      head.textContent = t.headline;
      detail.textContent = t.detail;
      send.hidden = !st.waiting;
    }).catch(() => undefined).finally(() => { pending = false; });
  };
  const off = onOutboxChange(refresh);
  const timer = window.setInterval(() => {
    if (!el.isConnected) {
      // dropped from the page: stop following the queue
      window.clearInterval(timer);
      off();
      return;
    }
    refresh();
  }, 5_000);
  refresh();
  return el;
}
